import React, {useContext} from "react";
import "./OpenSourceProjects.scss";
import {openSourceProjectsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function OpenSourceProjects() {
  const {isDark} = useContext(StyleContext);
  if (!openSourceProjectsSection.display) {
    return null;
  }
  const {title, subtitle, projects} = openSourceProjectsSection;

  function openLink(url) {
    if (url) window.open(url, "_blank");
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="open-source">
        <div className="open-source-main-div">
          <div className="open-source-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading open-source-heading"
                  : "heading open-source-heading"
              }
            >
              {title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle open-source-subtitle"
                  : "subTitle open-source-subtitle"
              }
            >
              {subtitle}
            </p>
          </div>
          <div className="open-source-cards-div">
            {projects.map((project, i) => (
              <div
                key={i}
                role="button"
                tabIndex={0}
                onClick={() => openLink(project.link)}
                onKeyDown={e => e.key === "Enter" && openLink(project.link)}
                className={
                  isDark
                    ? "dark-mode open-source-card open-source-card-dark"
                    : "open-source-card open-source-card-light"
                }
              >
                <h3
                  className={
                    isDark
                      ? "dark-mode open-source-card-title"
                      : "open-source-card-title"
                  }
                >
                  {project.title}
                </h3>
                <p
                  className={
                    isDark
                      ? "dark-mode open-source-card-description"
                      : "open-source-card-description"
                  }
                >
                  {project.description}
                </p>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={
                    isDark
                      ? "dark-mode open-source-card-link"
                      : "open-source-card-link"
                  }
                  onClick={e => e.stopPropagation()}
                >
                  View on npm
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}
